module.exports = __webpack_public_path__ + "img/pm2.5.cd70697e.png";